// 知识接口

import request from "@/util/request";

export function list(param) {
    return request({
        url: '/scheme',
        method: 'get',
        params: param
    })
}

export function saveOrUpdate(news) {
    return request({
        url: '/scheme',
        method: 'post',
        data: news
    })
}

export function getById(newsId) {
    return request({
        url: '/scheme/getById/' + newsId,
        method: 'get'
    })
}

export function deleteNews(newsId) {
    return request({
        url: '/scheme/delete',
        method: 'delete',
        params: {
            id: newsId
        }
    })
}

export function uploadCover(data) {
    return request({
        url: '/scheme/uploadCover',
        method: 'post',
        data: data
    })
}